export default __webpack_public_path__ + "static/media/logo_360.9af67920.png";